import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	panelSplitterLabel: {
		id: 'navigation.global-side-navigation.panel-splitter.label',
		description:
			'The accessible label for the panel splitter. Visually hidden but read by screen readers.',
		defaultMessage: 'Resize panel',
	},
});
